import { injectable } from "inversify";
import { ListingSearchModel, ListingSearchResult, ListingPriceQueryResult, ListingPriceRequestModel } from "@/modules/listing/model";
import { Bad, OkVal } from "@leavy/result";
import { PaginatedResult } from "@/modules/core/model";

@injectable()
export abstract class ListingService {
    abstract searchListingsByLocation(model: ListingSearchModel): Promise<OkVal<PaginatedResult<ListingSearchResult>> | Bad<"DURATION_NOT_SUPPORTED">>;
}
